export const language=["简体中文","English","Español","Português"]

import zh from '../assets/language/zh-cn.json'
import en from '../assets/language/en.json';
import es from '../assets/language/es.json';
import po from '../assets/language/po.json';
export function GetLanguagePack(lang:string){
    switch(lang){
        case "简体中文":
            return zh;
        case "English":
            return en;
        case "Español":
            return es;
        case "Português":
            return po
        default:
            return zh;
    }
}